import { RemoveIndexSignature } from '@intlify/core-base'
import * as Sentry from '@sentry/vue'
import passwordRegexp from 'password-regexp'
import { ComponentOptionsMixin, CreateComponentPublicInstance } from 'vue'
import { ComposerTranslation, LocaleMessageValue, VueMessageType } from 'vue-i18n'
import { Computed } from 'vuex'

/* eslint no-console: 1 */
const generalHelpers = {
	getWeekNumber(d: Date) {
		// Copy date so don't modify original
		d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
		// Set to nearest Thursday: current date + 4 - current day number
		// Make Sunday's day number 7
		d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
		// Get first day of year
		const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
		// Calculate full weeks to nearest Thursday
		const weekNo = Math.ceil(((d.getDate() - yearStart.getDate()) / 86400000 + 1) / 7)
		// Return array of year and week number
		return weekNo
	},
	isEmail(email: string) {
		const emailFormat = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
		if (email !== '' && email.match(emailFormat)) {
			return true
		} else {
			return false
		}
	},
	handleException(err: any) {
		Sentry.captureException(err)
	},
	processPassword(
		p:
			| CreateComponentPublicInstance<
					{},
					{
						t: ComposerTranslation<
							{},
							string,
							RemoveIndexSignature<{ [x: string]: LocaleMessageValue<VueMessageType> }>,
							never,
							never,
							never
							// Copy date so don't modify original
						>
					},
					{
						step: number
						twoFactorAuthenticationChosen: {}
						passwordInvalid: boolean
						qrInvalid: boolean
						activating: // Make Sunday's day number 7 // Set to nearest Thursday: current date + 4 - current day number
						boolean
						activated: boolean
						activationError: boolean
						userData: {
							// Make Sunday's day number 7
							password1: string
							password2: string
							qrCode: string
						}
						passwordErrors: never[]
					},
					{
						twoFactorAuthenticationChosenData(): any
						twoFactorAuthenticationOptions(): { name: string; description: string; id: number }[]
						headerText(): string
						passwordCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						qrCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						user: Computed
					},
					{
						login(): void
						qrCodeContinue(): void
						twoFactorAuthenticationSkipped(): void
						signup(): void
					},
					ComponentOptionsMixin,
					ComponentOptionsMixin,
					{},
					{},
					{},
					false,
					{},
					{},
					{ P: {}; B: {}; D: {}; C: {}; M: {}; Defaults: {} },
					{},
					{
						t: ComposerTranslation<
							{},
							string,
							RemoveIndexSignature<{ [x: string]: LocaleMessageValue<VueMessageType> }>,
							never,
							never,
							never
							// Copy date so don't modify original
						>
					},
					{
						step: number
						twoFactorAuthenticationChosen: {}
						passwordInvalid: boolean
						qrInvalid: boolean
						activating: // Make Sunday's day number 7 // Set to nearest Thursday: current date + 4 - current day number
						boolean
						activated: boolean
						activationError: boolean
						userData: {
							// Make Sunday's day number 7
							password1: string
							password2: string
							qrCode: string
						}
						passwordErrors: never[]
					},
					{
						twoFactorAuthenticationChosenData(): any
						twoFactorAuthenticationOptions(): { name: string; description: string; id: number }[]
						headerText(): string
						passwordCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						qrCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						user: Computed
					},
					{
						login(): void
						qrCodeContinue(): void
						twoFactorAuthenticationSkipped(): void
						signup(): void
					},
					{}
			  >
			| CreateComponentPublicInstance<
					{},
					{
						t: ComposerTranslation<
							{},
							string,
							RemoveIndexSignature<{ [x: string]: LocaleMessageValue<VueMessageType> }>,
							never,
							never,
							never
						>
					},
					{
						passwordInvalid: boolean
						updatingPassword: boolean
						updatedPassword: boolean
						updatePasswordError: boolean
						userData: { password1: string; password2: string }
						passwordErrors: never[]
					},
					{
						passwordCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						key: Computed
					},
					{ login(): void },
					ComponentOptionsMixin,
					ComponentOptionsMixin,
					{},
					{},
					{},
					false,
					{},
					{},
					{ P: {}; B: {}; D: {}; C: {}; M: {}; Defaults: {} },
					{},
					{
						t: ComposerTranslation<
							{},
							string,
							RemoveIndexSignature<{ [x: string]: LocaleMessageValue<VueMessageType> }>,
							never,
							never,
							never
						>
					},
					{
						passwordInvalid: boolean
						updatingPassword: boolean
						updatedPassword: boolean
						updatePasswordError: boolean
						userData: { password1: string; password2: string }
						passwordErrors: never[]
					},
					{
						passwordCSSBorder(): 'border-2 border-red-600' | 'border border-gray-300'
						key: Computed
					},
					{ login(): void },
					{}
			  >,
		password1: string | any[],
		password2: string
	) {
		const customRegexp = passwordRegexp({
			min: 8,
			numeric: true,
			uppercase: false,
			symbols: false // an option for symbols: ! @ # $ % ^ &
		})

		if (!password1) {
			return p.t('password-verification.errors.1')
		} else if (password1.length < 8) {
			return p.t('password-verification.errors.2')
		} else if (!customRegexp.test(password1)) {
			return p.t('password-verification.errors.3')
		} else if (!password2) {
			return p.t('password-verification.errors.4')
		} else if (password1 != password2) {
			return p.t('password-verification.errors.5')
		} else {
			return ''
		}
	}
}

export default generalHelpers
